import { createSlice } from "@reduxjs/toolkit";
import { getPagedPaymentHistoryReport } from "./thunk";
export const initialState = {
  // Get Paged Payment History Report
  getPagedPaymentHistoryReportData: [],
  isgetPagedPaymentHistoryReportSuccess: false,
  getPagedPaymentHistoryReportLoading: false,
  // Error Handling
  error: {},
};

const PaymentSlice = createSlice({
  name: "PaymentSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Paged Payment History Report
    builder.addCase(getPagedPaymentHistoryReport.pending, (state) => {
      state.getPagedPaymentHistoryReportLoading = true;
      state.error = false;
    });
    builder.addCase(
      getPagedPaymentHistoryReport.fulfilled,
      (state: any, action: any) => {
        state.getPagedPaymentHistoryReportData = action.payload;
        state.isgetPagedPaymentHistoryReportSuccess = true;
        state.getPagedPaymentHistoryReportLoading = false;
        state.error = false;
      }
    );
    builder.addCase(
      getPagedPaymentHistoryReport.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
        state.getPagedPaymentHistoryReportLoading = false;
      }
    );
  },
});

export default PaymentSlice.reducer;
